export default __webpack_public_path__ + "static/media/f_Logo-Grey-Logo.wine.da91cf07.svg";